import { Typography } from "@mui/material";
import { FC } from "react";
import { primary } from "@/theme/colors";

export const LoginPromoText: FC = () => {
  return (
    <Typography
      variant="body14Semi"
      color={primary[500]}
      textAlign="center"
      sx={{ px: 2 }}
    >
      アプリ版ではべんりに勉強できます。
    </Typography>
  );
};
